import { serviceNames, diContainer } from '../../service-setup/diContainer';
import { ProductRepository } from '../repositories/ProductRepository';

export class ProductLoadedUseCase {
    private productRepository: ProductRepository;
    private productId: string;

    constructor(productId: string) {
        this.productId = productId;
        this.productRepository = diContainer.get(serviceNames.productRepository);
    }

    public execute = async () => {
        await this.productRepository.retrieveProductById(this.productId);
    };
}
